import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'iniciaisNome'
})
export class IniciaisNomePipe implements PipeTransform {
  transform(nomeCompleto: string): string {
    if (!nomeCompleto) return '';

    const nomes = nomeCompleto.trim().split(' ');
    if (nomes.length === 1) return nomes[0][0].toUpperCase();

    const primeira = nomes[0][0];
    const ultima = nomes.at(-1)?.[0];
    return (primeira + ultima).toUpperCase();
  }
}
